import Logo from "../../img/circle-logo.png";

export function LogRegLogo() {
    function onClickLogo() {
        window.location.href = "/";
    }

    return (
        <img className={"cl"} src={Logo} alt={"logo"} onClick={onClickLogo} />
    );
  }
  